import React from 'react'
import PropTypes from 'prop-types'

import styles from './formControl.module.scss'

const FormControl = React.forwardRef(({ children, className = '', ...rest }, ref) => {
  return (
    <div ref={ref} className={`${styles.formControl} ${className}`} {...rest}>
      {children}
    </div>
  )
})

FormControl.displayName = 'FormControl'

FormControl.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
}

export { FormControl }
